import React, { Fragment } from 'react';
import { Button, Col, Container, Row, Card, CardBody } from 'reactstrap';
import { useRates } from '../../../hooks/rates/useRates';
import { ListCards } from '../../../components/cards/ListCards';
import { ModalRates } from '../../../components/rates/ModalRates';
import { ModalUpload } from '../../../components/rates/ModalUpload';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const IndexRates = () => {

    let filter = ["nameBrowser"];

    const {
        rates, branches, commercialLines, typeRate, method, validacionesRates,
        name, abbreviation, id_commercial_line, id_branch, id_type_rate, default_rate,
        handleInputChange, handleSelectValues, loading, branchDefault,
        toggle, modal, modalTitle, changeCheckbox, isMultiSelectOpen, selectedBranch,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        navigateConfigPrices,
        toggleDivCommercialLine,
        viewDivBranches,
        navigatePriceCost,
        downloadExcel,
        //*CONFIGURATION UPLOAD CSV
        UploadExams, handleUpload, handleOnChange, toggleModalUpload, modalUpload, handleCancellUpload,
        hasDefaultRate,
        isDelete, valueCode, setValueCode, confirmationUpdate, validCode,
        loadingExcel,fileName, removeFile, showDeleteAlert, modalAlert, closeDeleteAlert,
        handleClearRate, handleSearch, loadingExport,handleExportRate,searchRate

    } = useRates();

    
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_rate)}
                    title="Editar tarifario"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>

                <button
                    onClick={() => navigateConfigPrices(rowData.id_rate)}
                    title="Agregar precios"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#56b92e"
                    }}
                >
                    <i className="fa fa-money f-14"></i>
                </button>

                <button
                    onClick={() => downloadExcel(rowData.id_rate)}
                    title="Descargar Excel"
                    className="btnTableAction"
                    disabled={loadingExcel === rowData.id_rate}
                    style={{
                        backgroundColor: "#1e6b8a",
                        opacity: loadingExcel === rowData.id_rate ? 0.7 : 1
                    }}
                >
                    {
                        loadingExcel === rowData.id_rate
                            ? <i className="fa fa-spinner fa-spin"></i>
                            : <i className="fa fa-file-excel-o"></i>
                    }
                </button>

                <button
                    onClick={() => handleUpload(rowData.id_rate)}
                    title="Cargar Masiva"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#2c99f7"
                    }}
                >
                    <i className="icofont icofont-upload-alt"></i>
                </button>

                <button
                    onClick={() => handleDelete(rowData.id_rate)}
                    title="Eliminar tarifario"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#db1717"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>

               
            </div>
        );
    };

    return (
        <Fragment>
            {/* <Breadcrumb parent="Configuraciones" title="Tarifario fat"  /> */}
            <div className='container-global-zoom p-4'>
                <Row>
                    <Col sm="12">

                    <Card>
                        <CardBody className="p-1">

                            <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                <TitleDataTable
                                    titleTable="Catálogos de Tarifarios"
                                    buttonActions={handleExportRate}
                                    titleButton="Excel de tarifario"
                                    isDisbled={loadingExport}
                                    loadingIsDisabled={loadingExport}
                                    titleCreate="Crear tarifario"
                                    buttonActionsCreate={handleCreate}
                                    actionInput={handleSearch}
                                    valueFilter={searchRate}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearRate}
                                />
                            </Col>
                        
                            <div className="table-responsive">
                                <DataTable
                                    value={rates}
                                    paginator
                                    rows={10}
                                    responsiveLayout="scroll"
                                    rowsPerPageOptions={[10, 50, 100]} 
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    emptyMessage={
                                        <div className="text-center">
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                style={{ width: "32%" }}
                                                alt="Sin resultados"
                                            />
                                            <br />
                                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                No se encontraron resultados.
                                            </p>
                                        </div>
                                    }
                                >

                                    <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                    <Column 
                                        field="name" 
                                        header="Nombre" 
                                        headerStyle={headerStyle} 
                                        style={cellStyle}
                                        body={(rowData) => (
                                            <span style={{ fontWeight: "bold" }}>
                                                {rowData.name}
                                            </span>
                                        )}
                                    />

                                    <Column 
                                        field="abbreviation" 
                                        header="Clave" 
                                        headerStyle={headerStyle} 
                                        style={cellStyle}
                                        body={(rowData) => (
                                            <span>
                                                {rowData.abbreviation}
                                            </span>
                                        )}
                                    />

                                    <Column 
                                        field="short_name_commercial_line" 
                                        header="Razón social" 
                                        headerStyle={headerStyle} 
                                        style={cellStyle}
                                        body={(rowData) => (
                                            <span>
                                                {rowData.short_name_commercial_line}
                                            </span>
                                        )}
                                    />

                                    <Column 
                                        field="name_type_rate"
                                        header="Tipo de tarifario" 
                                        body={(rowData) => (
                                            <span>
                                                {rowData.name_type_rate}
                                            </span>
                                        )}
                                        headerStyle={headerStyle} 
                                        style={cellStyle} 
                                    />

                                    <Column 
                                        field="abbreviation_type_rate" 
                                        header="Abreviación tipo de tarifario" 
                                        headerStyle={headerStyle} 
                                        style={cellStyle}
                                        body={(rowData) => (
                                            <span>
                                                {rowData.abbreviation_type_rate}
                                            </span>
                                        )}
                                    />
                                    
                                    <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                </DataTable>
                            </div>
                        </CardBody>
                    </Card>

                          
                    </Col>
                </Row>
                <Row>
                    {/* <Col md="12">
                        <ListCards
                            filterProps={filter}
                            type="list"
                            inputFiter={true}
                            items={rates}
                            {...{ handleUpdate, handleDelete }}
                            methodsAbsolutes={
                                [
                                    {
                                        type: 'linkId',
                                        method: navigateConfigPrices,
                                        icon: 'icofont icofont-cur-dollar f-14',
                                        colorBtn: 'primary',
                                        titleToolTip: "Agregar precios"
                                    },
                                    // {
                                    //     type: 'linkId',
                                    //     method: navigatePriceCost,
                                    //     icon: 'fa fa-money f-14',
                                    //     colorBtn: 'success',
                                    //     titleToolTip: ""                                    
                                    // },
                                    {
                                        type: 'linkId',
                                        method: downloadExcel,
                                        icon: 'fa fa-file-excel-o',
                                        colorBtn: 'success',
                                        titleToolTip: "Descargar Excel"
                                    },
                                    {
                                        type: 'linkId',
                                        method: handleUpload,
                                        icon: 'icofont icofont-upload-alt',
                                        colorBtn: 'success',
                                        titleToolTip: "Cargar Masiva"
                                    }
                                ]
                            }
                        />
                    </Col> */}
                </Row>
            </div>
            <ModalRates
                {
                ...{
                    branches, commercialLines, typeRate, modal, toggle, modalTitle, method, loading,
                    handleInputChange, handleSelectValues, validacionesRates,
                    name, abbreviation, id_commercial_line, id_branch, id_type_rate, default_rate,
                    saveCreate, saveUpdate, saveDelete, selectedBranch,
                    toggleDivCommercialLine, changeCheckbox,
                    viewDivBranches, branchDefault, isMultiSelectOpen,
                    hasDefaultRate,
                    isDelete, valueCode, setValueCode, confirmationUpdate, validCode

                }
                }
            />
            <ModalUpload
                {
                ...{ UploadExams, handleOnChange, toggleModalUpload, modalUpload, handleCancellUpload,fileName,removeFile, }
                }
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar Tarifario "
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el tarifario? Esto eliminara la lista de precios"
                    alert1={true}
                    titleAlert1={name}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                />

            )}
        </Fragment>
    )
}
